module.exports = __webpack_public_path__ + "img/icon_logo_jita_232.92f09387.png";